import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["description", "iconKey", "className", "children"];
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { setPreventUnload } from 'flow/actions/app-actions';
import BaseButton from './BaseButton';
import Icon from './Icon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Stacked GeneralLinks touch, so the focused one is lifted above its
// neighbours: otherwise the next one's background covers the bottom of its
// focus ring.
var baseClassName = 'relative flex w-full items-center justify-between rounded-sm p-2 text-start hover:bg-gray-100 focus-visible:z-10';

// With `href`, a link that opens in a new window; with `onClick`, a button for
// an action. Both are native elements, so they are in the Tab order and the
// keyboard activates them. Only phrasing content (spans) may go inside a button.
var GeneralLink = function GeneralLink(_ref) {
  var description = _ref.description,
    iconKey = _ref.iconKey,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      children: children
    }), /*#__PURE__*/_jsxs("span", {
      className: "flex items-center gap-x-1",
      children: [/*#__PURE__*/_jsx("span", {
        className: "text-sm text-gray-500",
        children: description
      }), iconKey ? /*#__PURE__*/_jsx(Icon, {
        iconKey: iconKey
      }) : null]
    })]
  });
  if (props.href !== undefined) {
    return /*#__PURE__*/_jsx("a", {
      href: props.href,
      target: "_blank",
      rel: "noreferrer",
      className: twMerge('focus-ring', baseClassName, className)
      // Skips the clearState on beforeunload; see TicketsIntroView.
      ,
      onClick: function onClick() {
        return setPreventUnload(true);
      },
      children: content
    });
  }
  return /*#__PURE__*/_jsx(BaseButton, {
    type: "button",
    className: twMerge(baseClassName, className),
    onClick: props.onClick,
    children: content
  });
};
export default GeneralLink;